/**
 * Return true if start time is less than end time
 */
var isValidTimeSelection = function (startTime, endTime) { return startTime < endTime; };
export default isValidTimeSelection;
//# sourceMappingURL=isValidTimeSelection.js.map